import React from 'react';
import { Skeleton } from '@nextui-org/react';

const DispertionChartSkeleton: React.FC = () => {
  return (
    <div className='bg-background p-4 rounded-lg shadow'>
      <Skeleton className='h-8 w-3/5 rounded-lg mb-4' />
      <div className='flex items-center space-x-2 my-4'>
        <Skeleton className='h-10 w-48 rounded-lg' />
        <Skeleton className='h-10 w-48 rounded-lg' />
      </div>
      <Skeleton className='h-96 w-full rounded-lg' />
    </div>
  );
};

export default DispertionChartSkeleton;
